import apiConfig from "../ApiConfig";

// ================= AI Virtual SOC =================
// Thin wrappers around the real /api/soc/ backend (virtual_soc app).
// apiConfig already attaches the Cognito Bearer token via its request
// interceptor (see ApiConfig.js) - nothing here builds auth headers
// manually, matching the pattern used by DashboardApis.js etc.

// ---- Dashboard ----
export const fetchSOCDashboard = async () => {
  const response = await apiConfig.get("/api/soc/dashboard/");
  return response.data;
};

// ---- Alerts ----
export const fetchSOCAlerts = async (params = {}) => {
  const response = await apiConfig.get("/api/soc/alerts/", { params });
  return response.data;
};

export const fetchSOCAlertById = async (alertId) => {
  const response = await apiConfig.get(`/api/soc/alerts/${alertId}/`);
  return response.data;
};

export const updateSOCAlertStatus = async (alertId, status, analyst) => {
  const response = await apiConfig.patch(`/api/soc/alerts/${alertId}/status/`, {
    status,
    ...(analyst ? { analyst } : {}),
  });
  return response.data;
};

export const markSOCAlertRead = async (alertId) => {
  const response = await apiConfig.patch(`/api/soc/alerts/${alertId}/read/`, {});
  return response.data;
};

// ---- Assets ----
export const fetchSOCAssets = async (params = {}) => {
  const response = await apiConfig.get("/api/soc/assets/", { params });
  return response.data;
};

export const fetchSOCAssetById = async (assetId) => {
  const response = await apiConfig.get(`/api/soc/assets/${assetId}/`);
  return response.data;
};

// ---- Incidents ----
export const fetchSOCIncidents = async (params = {}) => {
  const response = await apiConfig.get("/api/soc/incidents/", { params });
  return response.data;
};

export const fetchSOCIncidentById = async (incidentId) => {
  const response = await apiConfig.get(`/api/soc/incidents/${incidentId}/`);
  return response.data;
};

export const createSOCIncident = async (data) => {
  const response = await apiConfig.post("/api/soc/incidents/create/", data);
  return response.data;
};

export const updateSOCIncidentStatus = async (incidentId, status, resolution) => {
  const response = await apiConfig.patch(`/api/soc/incidents/${incidentId}/status/`, {
    status,
    ...(resolution ? { resolution } : {}),
  });
  return response.data;
};

// ---- Events / Logs ----
export const fetchSOCEvents = async (params = {}) => {
  const response = await apiConfig.get("/api/soc/events/", { params });
  return response.data;
};

export const fetchSOCEventById = async (eventId) => {
  const response = await apiConfig.get(`/api/soc/events/${eventId}/`);
  return response.data;
};

// ---- Investigations ----
export const fetchSOCInvestigations = async (params = {}) => {
  const response = await apiConfig.get("/api/soc/investigations/", { params });
  return response.data;
};

export const fetchSOCInvestigationById = async (investigationId) => {
  const response = await apiConfig.get(`/api/soc/investigations/${investigationId}/`);
  return response.data;
};

export const createSOCInvestigation = async (data) => {
  const response = await apiConfig.post("/api/soc/investigations/create/", data);
  return response.data;
};

export const updateSOCInvestigationStatus = async (investigationId, status) => {
  const response = await apiConfig.patch(`/api/soc/investigations/${investigationId}/status/`, { status });
  return response.data;
};

// ---- Response Actions ----
export const fetchSOCResponseActions = async (params = {}) => {
  const response = await apiConfig.get("/api/soc/response/", { params });
  return response.data;
};

export const createSOCResponseAction = async (data) => {
  const response = await apiConfig.post("/api/soc/response/create/", data);
  return response.data;
};

export const updateSOCResponseActionStatus = async (actionId, status) => {
  const response = await apiConfig.patch(`/api/soc/response/${actionId}/status/`, { status });
  return response.data;
};

// ---- Reports ----
export const fetchSOCReports = async (params = {}) => {
  const response = await apiConfig.get("/api/soc/reports/", { params });
  return response.data;
};

export const fetchSOCReportById = async (reportId) => {
  const response = await apiConfig.get(`/api/soc/reports/${reportId}/`);
  return response.data;
};

export const generateSOCReport = async (data) => {
  const response = await apiConfig.post("/api/soc/reports/generate/", data);
  return response.data;
};

export const downloadSOCReport = async (reportId) => {
  const response = await apiConfig.get(`/api/soc/reports/${reportId}/download/`, {
    responseType: "blob",
  });
  return response.data;
};

// ---- Threat Intelligence ----
export const fetchSOCThreatIntel = async (params = {}) => {
  const response = await apiConfig.get("/api/soc/threat-intel/", { params });
  return response.data;
};
